/** 비교용 이미지 주소. https만 받는다(혼합 콘텐츠·javascript: 등 차단). */
export function parseImageUrl(input: string): string | null {
  try {
    const u = new URL(input.trim());
    return u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}
